import cx from 'classnames';
import LayerWithArrow, {
  Props as LayerWithArrowProps,
  InjectedProps as LayerWithArrowInjectedProps,
} from 'components/LayerWithArrow';
import * as React from 'react';

import './styles/Hovercard.scss';

/**
 * ## Card shown via trigger.
 * ### Used to display contextual content in a layer above the app in an uninterruptive way.
 *
 * # Implementation
 *
 * Invoke with [HoverLayerTrigger](/internal/components/HoverLayerTrigger) or
 * [LayerTrigger](/internal/components/LayerTrigger).
 *
 *
 * # Common usage
 *
 * ```example
 * <HoverLayerTrigger
 *   defaultLayerShown
 *   layer={
 *     <Hovercard>
 *       <HovercardBody>
 *         Hovercard
 *       </HovercardBody>
 *     </Hovercard>
 *   }>
 *   <Button>Hover</Button>
 * </HoverLayerTrigger>
 * ```
 *
 * # Minimal children
 *
 * ```example
 * <HoverLayerTrigger
 *   defaultLayerShown
 *   layer={
 *     <Hovercard>
 *       Hovercard
 *     </Hovercard>
 *   }>
 *   <Button>Hover</Button>
 * </HoverLayerTrigger>
 * ```
 */

type Props = {
  className?: string;
  children: React.ReactNode;
  /**
   * **Use only for tests**, skip the whole "render in a modal"
   * behavior so that we can render the modal content in whatever
   * layout we decide in tests.
   *
   **/
  skip?: boolean;
} & LayerWithArrowProps &
  LayerWithArrowInjectedProps;

class Hovercard extends React.Component<Props> {
  render() {
    const { children, className } = this.props;

    if (this.props.skip) {
      return <div className={cx('Hovercard', className)}>{children}</div>;
    }
    return (
      <LayerWithArrow
        {...this.props}
        className={cx('Hovercard', className)}
        arrowClassName="Hovercard-arrow"
      >
        {children}
      </LayerWithArrow>
    );
  }
}

export default Hovercard;
